import { render, staticRenderFns } from "./modal-data-form.vue?vue&type=template&id=454747a9&scoped=true&"
import script from "./modal-data-form.vue?vue&type=script&lang=js&"
export * from "./modal-data-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454747a9",
  null
  
)

export default component.exports